<template>
  <div class="md-card md-card-tabs">
     <h4
      class="md-card-header font_bold"
    >{{$t('sortTop5.debtors.title')}}</h4>
  
    <div class="md-card-content">
      <el-table :data="tableData" :emptyText="$t('dashboard.statistics.empty')" style="width: 100%">
        <el-table-column prop="index" label width="20"></el-table-column>
        <el-table-column
          v-for="(item,index) in lableList"
          :key="index"
          :prop="item.field"
          :label="item.prop"
          width="180"
          :align="item.align"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {formatAsMoneyAmount, formatAsDecimal} from "@/common/format";

export default {
  props: {
    type: String
  },
  data() {
    return {
      tableData: [],
      lableList: [
        { prop: "", field: "debtorName", width: "", align: "left" },
        {
          prop: this.$t("dashboard.buyCardList.1"),
          field: "boughtReceivableVolume",
          width: "",
          align: "right"
        },
        {
          prop: this.$t("dashboard.buyCardList.2"),
          field: "totalInvestmentVolume",
          width: "",
          align: "right"
        },
        {
          prop: this.$t("dashboard.buyCardList.4"),
          field: "avgExpectedRoi",
          width: "",
          align: "right"
        },
        {
          prop:this.$t("dashboard.buyCardList.5"),
          field: "avgEffectiveRoi",
          width: "",
          align: "right"
        },
        {
          prop:this.$t("dashboard.buyCardList.6"),
          field: "durationDays",
          width: "",
          align: "right"
        }
      ]
    };
  },
  methods: {
    indexMethod(index) {
      return index * 2;
    }
  },
  computed: {
    ...mapGetters({
      dashboardInfo: "dashboardInfo",
      dashboardFilter: "dashboardFilter"
    })
  },
  watch: {
    dashboardInfo() {
      let { statisticData } = this.dashboardInfo;
      let { currency } = this.dashboardFilter;
      if (
        statisticData &&
        statisticData.topDebtors &&
        statisticData.topDebtors.length > 0
      ) {
        this.tableData = statisticData.topDebtors.map((item, index) => {
          item.index = index + 1;
          item.boughtReceivableVolume = formatAsMoneyAmount(item.boughtReceivableVolume, {currency: currency});
          item.totalInvestmentVolume = formatAsMoneyAmount(item.totalInvestmentVolume) + " " + currency;
          item.avgExpectedRoi = formatAsDecimal(item.avgExpectedRoi,{showPercentSign:true});
          item.avgEffectiveRoi = formatAsDecimal(item.avgEffectiveRoi,{showPercentSign:true});
          item.durationDays = formatAsDecimal(item.durationDays, {decimals: 0});
          return item;
        });
      }
    }
  }
};
</script>
